<section class="job-pre-notification-page">
  <section class="job-pre-notification-card">
    <header class="page-header">
      <h1 class="main-heading sam-page-heading">FÖRANMÄLAN JOBB</h1>
      <p class="intro-text">
        Föranmäl arbetet till oss genom att välja kund, beskriva uppdraget och ange den tid du avser att arbeta. 
        När du sparat den hittar du underlaget i din fakturalista. Från fakturalistan kan du sedan välja att göra det till en faktura. 
      </p>
    </header>

    <nav class="job-pre-notification-steps" aria-label="Föranmälans delar">
      <button type="button" class="job-pre-notification-step" (click)="scrollToSection('job-customer-section')"><span>1</span><strong>Kund</strong></button>
      <button type="button" class="job-pre-notification-step" (click)="scrollToSection('job-description-section')"><span>2</span><strong>Beskrivning</strong></button>
      <button type="button" class="job-pre-notification-step" (click)="scrollToSection('job-working-time-section')"><span>3</span><strong>Arbetstid</strong></button>
    </nav>

  <div class="page-content">
  <div class="row section">
    <div id="job-customer-section" class="col-12 section-header">
      <span class="section-header-icon" aria-hidden="true"><mat-icon>person_outline</mat-icon></span>
      <h2 class="accent">1. Kund</h2>
    </div>

    <div
      class="col-sm-12 select-customer"
      [class.col-md-8]="invoice?.Customer?.Id > 0"
      [class.col-lg-6]="invoice?.Customer?.Id > 0"
      [class.col-md-12]="!invoice?.Customer?.Id"
      [class.col-lg-12]="!invoice?.Customer?.Id"
      [class.customer-selection-only]="!invoice?.Customer?.Id"
    >
      <mat-card class="select-customer-card">
        <mat-card-title>
          Välj en kund
          <mat-icon
            color="accent"
            class="info-icon"
            matTooltip="Om mottagaren är privatperson så behöver inte referens finnas med"
            matTooltipPosition="after"
            >info</mat-icon
          >
        </mat-card-title>

        <div class="row">
          <div class="col-9">
            <mat-form-field appearance="fill" floatLabel="always" class="customer-select-field">
              <mat-label>Ange mottagare</mat-label>
              <mat-select
                [(ngModel)]="invoice.Customer.Id"
                (ngModelChange)="customerChange($event)"
              >
                <mat-option [value]="0"></mat-option>
                <mat-option *ngFor="let c of companies" [value]="c.Id">
                  {{ c.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3 action-buttons">
            <button mat-stroked-button color="accent" class="customer-action" (click)="addCustomer()" aria-label="Lägg till ny kund" matTooltip="Lägg till ny kund">
              <mat-icon>person_add</mat-icon>
            </button>

            <button
              mat-stroked-button
              color="accent"
              class="customer-action"
              *ngIf="invoice?.Customer?.Id"
              (click)="editCustomer()"
              aria-label="Redigera kund"
              matTooltip="Redigera kund"
            >
              <mat-icon class="edit-icon">edit</mat-icon>
            </button>
          </div>
        </div>

        <div class="row" *ngIf="invoice?.Customer?.Id && (invoice?.Customer?.IsCompany || selectedCustomer?.IsCompany || (contacts && contacts.length) || invoice?.Reference?.Id || invoice?.Reference?.Name)">
          <div class="col-9">
              <mat-form-field appearance="fill" floatLabel="always" class="customer-select-field">
                <mat-label>Din kontaktperson*</mat-label>
                <mat-select
                  [disabled]="!contacts || contacts.length === 0"
                  [(ngModel)]="invoice.Reference.Id"
                  (ngModelChange)="contactChange($event)"
                >
                <mat-option *ngFor="let c of contacts" [value]="c.Id">
                  {{ c.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3 action-buttons" *ngIf="invoice?.Customer?.Id && (invoice?.Customer?.IsCompany || selectedCustomer?.IsCompany || (contacts && contacts.length) || invoice?.Reference?.Id || invoice?.Reference?.Name)">
            <button mat-stroked-button color="accent" class="customer-action" (click)="addContact()" aria-label="Lägg till ny kontakt" matTooltip="Lägg till ny kontakt">
              <mat-icon>person_add</mat-icon>
            </button>

            <button
              mat-stroked-button
              color="accent"
              class="customer-action"
              *ngIf="invoice?.Reference?.Id"
              (click)="editContact(invoice.Reference)"
              aria-label="Redigera kontakt"
              matTooltip="Redigera kontakt"
            >
              <mat-icon class="edit-icon">edit</mat-icon>
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <div class="col-sm-12 col-md-8 col-lg-6" *ngIf="invoice?.Customer?.Id > 0 && selectedCustomer">
      <mat-card class="customer-summary">
        <h3>{{ selectedCustomer.Name }}</h3>
        <p *ngIf="selectedCustomer.OrgNumber">{{ selectedCustomer.OrgNumber }}</p>
        <p>
          {{ selectedCustomer.Address }}<br />
          {{ selectedCustomer.Zip }} {{ selectedCustomer.City }}
        </p>        
        <p *ngIf="invoice.Reference?.Name">
          Kontakt: {{ invoice.Reference.Name }}
          <span *ngIf="invoice.Reference.Email">({{ invoice.Reference.Email }})</span>
        </p>
      </mat-card>
    </div>
  
    <div id="job-description-section" class="col-12 section-header">
      <span class="section-header-icon" aria-hidden="true"><mat-icon>description</mat-icon></span>
      <h2 class="accent">2. Beskrivning</h2>
    </div>

    <div class="col-12" *ngIf="canAddInvoiceItem() || isEditingDescription">
      <mat-card>
        <mat-card-title>Beskrivning av planerat arbete</mat-card-title>
        <p>
          Beskriv vad som ska utföras.
        </p>
        <mat-form-field appearance="fill" floatLabel="always" style="width:100%;" class="description-field">
          <mat-label>Beskrivning *</mat-label>
          <textarea
            matInput
            rows="3"
            [(ngModel)]="pendingGroup.Description"
            (ngModelChange)="pendingError = ''"
            [disabled]="isEditingWorkedHours || (!canAddInvoiceItem() && !isEditingDescription)"
          ></textarea>
        </mat-form-field>
        <div class="pending-actions">
          <div class="calendar-button-wrapper">
            <button
              *ngIf="hasPendingDescriptionDraft()"
              mat-stroked-button
              type="button"
              class="calendar-button"
              (click)="cancelDescriptionEditing()"
            >
              Avbryt
            </button>
            <button
              *ngIf="isEditingDescription"
              mat-icon-button
              color="warn"
              type="button"
              aria-label="Ta bort beskrivning"
              (click)="deleteEditingDescription()"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <button
              mat-flat-button
              color="accent"
              class="calendar-button"
              (click)="saveDescriptionGroup()"
              [disabled]="(!canAddInvoiceItem() && !isEditingDescription) || !invoice?.Customer?.Id || !pendingGroup?.Description?.trim()"
            >
              {{ isEditingDescription ? 'Spara beskrivning' : 'Lägg till beskrivning' }}
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <div class="col-12" *ngIf="invoice.InvoiceGroups.length > 0 && !isEditingDescription">
      <mat-card class="time-group" *ngFor="let group of invoice.InvoiceGroups">
        <div class="time-group-header" style="align-items:flex-start;">
          <div>
            <mat-card-title>Beskrivning av planerat arbete</mat-card-title>
            <p>{{ group.Description }}</p>
          </div>
          <div class="group-actions" style="align-self:flex-end;">
            <button
              mat-flat-button
              color="accent"
              class="calendar-button"
              (click)="editDescriptionGroup(group)"
            >
              Redigera beskrivning
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <div id="job-working-time-section" class="col-12 section-header">
      <span class="section-header-icon" aria-hidden="true"><mat-icon>schedule</mat-icon></span>
      <h2 class="accent">3. Arbetstid</h2>
    </div>

    <div class="col-12">
      <mat-card>
        <mat-card-title>Föranmäl planerad arbetstid</mat-card-title>
        <p>
          Välj datum och ange de dagar du kommit överens om med din uppdragsgivare.
          Detta kan användas som underlag för fakturering senare. I så fall behöver du göra en ny föranmälan per planerad faktura.
        </p>
        <div class="row pending-calendar-row">
          <div class="col-lg-6 col-md-12">
              <mat-form-field appearance="fill" floatLabel="always" style="width:100%;" class="working-title-field">
              <mat-label>Befattning/titel/yrke *</mat-label>
              <input
                matInput
                [ngModel]="(workedHoursGroup && !isEditingWorkedHours) ? workedHoursGroup.WorkingTitle : pendingGroup.WorkingTitle"
                (ngModelChange)="pendingGroup.WorkingTitle = $event"
                [disabled]="workedHoursGroup && !isEditingWorkedHours"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-6 col-md-12">
            <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
              <mat-label>Land där arbetet utförs</mat-label>
              <mat-select [(ngModel)]="invoice.WorkCountry">
                <mat-option *ngFor="let country of countries" [value]="country?.Name">
                  {{ country?.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="pending-calendar">
          <div class="row pending-calendar-row">
            <div class="col-lg-6 col-md-12 calendar-wrapper">
              <mat-calendar
                [selected]="pendingCalendarDate"
                [disabled]="workedHoursGroup && !isEditingWorkedHours"
                (selectedChange)="onCalendarDateSelected($event)"
              ></mat-calendar>
              <small class="calendar-hint">Välj datum för att lägga till planerad tid.</small>
            </div>
            <div class="col-lg-6 col-md-12">
              <div *ngIf="(isEditingWorkedHours || !workedHoursGroup) ? pendingGroup.InvoiceRows?.length : workedHoursGroup?.InvoiceRows?.length; else noPendingRows">
                <div
                  class="pending-time-row"
                  *ngFor="let row of (isEditingWorkedHours || !workedHoursGroup) ? pendingGroup.InvoiceRows : workedHoursGroup?.InvoiceRows"
                >
                  <div class="pending-time-date">{{ row.StartDate | swedishDate: 'yyyy-MM-dd' }}</div>
                  <div class="pending-time-inputs">
                    <mat-form-field appearance="fill" floatLabel="never" class="time-select">
                      <mat-select aria-label="Arbetade timmar" [(ngModel)]="row.HoursWorked" [ngModelOptions]="{ standalone: true }" [disabled]="workedHoursGroup && !isEditingWorkedHours">
                        <mat-option *ngFor="let hour of hoursOptions" [value]="hour">{{ hour }} h</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill" floatLabel="never" class="time-select">
                      <mat-select aria-label="Arbetade minuter" [(ngModel)]="row.MinutesWorked" [ngModelOptions]="{ standalone: true }" [disabled]="workedHoursGroup && !isEditingWorkedHours">
                        <mat-option *ngFor="let minute of minuteOptions" [value]="minute">{{ minute }} min</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      mat-icon-button
                      color="warn"
                      type="button"
                      aria-label="Ta bort rad"
                      [disabled]="(workedHoursGroup && !isEditingWorkedHours) || isRowInPast(row)"
                      (click)="removePendingRow(row.Id)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                    <span class="pre-notified-label" *ngIf="isPreNotifiedRow(row)">f&ouml;ranm&auml;ld</span>
                  </div>
                </div>
              </div>
              <ng-template #noPendingRows>
                <p class="no-time-placeholder">Inga tider tillagda ännu.</p>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="pending-actions">
          <div class="calendar-button-wrapper">
            <button
              *ngIf="hasPendingWorkedHoursDraft()"
              mat-stroked-button
              type="button"
              class="calendar-button"
              (click)="cancelWorkedHoursEditing()"
            >
              Avbryt
            </button>
            <button
              mat-flat-button
              color="accent"
              class="calendar-button"
              (click)="workedHoursGroup && !isEditingWorkedHours ? editWorkedHoursGroup() : openPendingCalendar()"
              [disabled]="!invoice?.Customer?.Id || (isEditingWorkedHours ? pendingGroup?.InvoiceRows?.length === 0 : !workedHoursGroup?.InvoiceRows?.length && pendingGroup?.InvoiceRows?.length === 0)"
            >
              {{
                isEditingWorkedHours
                  ? 'Spara arbetad tid'
                  : (workedHoursGroup?.InvoiceRows?.length ? 'Redigera planerad arbetstid' : 'Lägg till planerad arbetstid')
              }}
            </button>
          </div>
          <div class="error-message" *ngIf="pendingError">{{ pendingError }}</div>
        </div>
      </mat-card>
    </div>
    <div class="col-lg-12 col-md-12 align-self-center section-actions" style="margin-top: 15px;">
      <mat-card class="save-card">
        <div class="summary-and-action">
          <div class="summary-text">
            <h3>Sammanfattning</h3>
            <p>Totalt antal timmar: {{ hoursWorkedTotal | number: '1.2-2' }}</p>
            <p>Totalt antal dagar: {{ totalDays }}</p>
          </div>
          <div class="save-button-wrapper">
            <button
              mat-raised-button
              color="accent"
              class="save-button"
              (click)="save()"
              [disabled]="!canSaveJobPreNotification()"
            >
              {{ isSaving ? 'Sparar...' : 'Spara föranmälan' }}
            </button>
            <div class="error-message" *ngIf="saveError">{{ saveError }}</div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  </div>
  </section>
</section>



